import { Content } from '../../squidex';

export class UserModel extends Content {
  constructor(current?: Content) {
    if (current) {
      super(current);
    } else {
      super({});
    }
  }
}
